import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import StatsCard from "./StatsCard";
import classes from "./AssignmentResult.module.css";

import { MButton } from "../../../../../UI";

import CloseIcon from "@material-ui/icons/Close";
import CurrentRankIcon from "../../../../../assets/img/assessmentLearnImages/currentRank.svg";
import TimeSpentIcon from "../../../../../assets/img/assessmentLearnImages/timeSpent.svg";
import PercentageIcon from "../../../../../assets/img/assessmentLearnImages/percentage.svg";
import AccuracyIcon from "../../../../../assets/img/assessmentLearnImages/accuracy.svg";

import {
  getResult,
  getAssessmentResponce,
} from "../../../../../store/actions/questionAnswer.action";
import moment from "moment";

import { withTranslation } from "react-i18next";

import { Doughnut } from "react-chartjs-2";
import RollBackPopup from "../../../RollBack/RollBackPopup";
import { ScoreWheel } from "./ScoreWheel";

class AssignmentResult extends Component {
  state = {
    score: 0,
    correct: 0,
    wrong: 0,
    unattempted: 0,
    accuracy: 0,
    percentage: 0,
    startedOn: "",
    endedOn: "",
    rank: "",
    totalNumberOfResponses: "",
    timeSpent: "",
    totalMarks: 0,
  };
  async componentDidMount() {
    let assessmentId = localStorage.getItem("_assessmentId");
    let userId = localStorage.getItem("kneuraId");
    await this.props.getAssessmentResponce(assessmentId, userId);
    await this.props.getResult(this.props.assessmentResponse.id);
  }
  componentWillReceiveProps(props) {
    if (props.result !== this.props.result) {
      // const timeSpent = moment(props.result.endedOn.diff(props.result.startedOn, 'minutes', true))
      let timeSpent = moment(props.result.endedOn).diff(
        props.result.startedOn,
        "minutes",
        true
      );
      timeSpent = timeSpent.toFixed(0);
      this.setState({ ...props.result, timeSpent: timeSpent });
      // this.setState({ ...props.result })
    }
  }

  goToSeeSlotuion = () => {
    this.props.history.push("/seesolution");
  };

  onCloseHandler = () => {
    this.props.history.goBack();
  };
  render() {
    const { t } = this.props;
    return (
      <Fragment>
        <RollBackPopup />
        <div className={classes.MainBody}>
          {/* Header */}
          <div>
            {this.props.isKtvAssessment ? (<div> </div>) : (<MButton
              className={classes.CloseBtn}
              variant="contained"
              onClick={this.onCloseHandler}
              autoFocus
            >
              <CloseIcon />
            </MButton>)}
          </div>
          {/* Body */}
          <div className={classes.Body}>
            <h1 style={{ color: "rgba(52, 73, 94, 0.75)" }}>
              {this.props.assessmentData.name}
            </h1>
            {/* <div
              style={{
                marginBottom: "2vh",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  marginRight: "-15.8%",
                  marginLeft: "-1.38%",
                  position: "relative",
                }}
              >
                <Doughnut
                  width="1600"
                  height="225"
                  data={{
                    datasets: [
                      {
                        data: [
                          this.state.score,
                          this.state.totalMarks - this.state.score,
                        ],
                        backgroundColor: [
                          "rgba(52, 73, 94, 0.75)",
                          "rgba(52, 73, 94, 0.25)",
                        ],
                        borderColor: "transparent",
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                    cutoutPercentage: 85,
                    tooltips: { enabled: false },
                    hover: { mode: null },
                  }}
                />
                <div
                  style={{ position: "absolute", left: "48.5%", top: "34%" }}
                >
                  <p>{t("Score")}</p>
                  <p>
                    {this.state.score} / {this.state.totalMarks}{" "}
                  </p>
                </div>
              </div>
              <div style={{ position: "relative", marginLeft: "-26.5%" }}>
                <Doughnut
                  width="1600"
                  height="225"
                  style={{ margin: "0" }}
                  data={{
                    datasets: [
                      {
                        data: [
                          this.state.correct,
                          this.state.wrong,
                          this.state.unattempted,
                        ],
                        backgroundColor: [
                          "#8EC563",
                          "#C8716A",
                          "rgba(52, 73, 94, 0.25)",
                        ],
                        borderColor: "transparent",
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                    cutoutPercentage: 85,
                    tooltips: { enabled: false },
                    hover: { mode: null },
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    left: "46.8%",
                    top: "41%",
                    width: "auto",
                  }}
                >
                  <p style={{ margin: "0" }}>
                    {" "}
                    <span style={{ color: "#8EC563" }}>
                      {this.state.correct}
                    </span>{" "}
                    {t("Correct")}{" "}
                  </p>
                  <p style={{ margin: "0" }}>
                    {" "}
                    <span style={{ color: "#C8716A" }}>
                      {this.state.wrong}
                    </span>{" "}
                    {t("Wrong")}{" "}
                  </p>
                  <p style={{ margin: "0" }}>
                    {" "}
                    <span style={{ color: "#34495E" }}>
                      {this.state.unattempted}
                    </span>{" "}
                    {t("Unattempted")}{" "}
                  </p>
                </div>
              </div>
            </div>
             */}

            <ScoreWheel
              correct={this.state.correct}
              score={this.state.score}
              totalMarks={this.state.totalMarks}
              unattempted={this.state.unattempted}
              wrong={this.state.wrong}
            />

            <div>
              <StatsCard
                imgUrl={CurrentRankIcon}
                cardLabel="Current Rank"
                cardBody={
                  this.state.rank + " / " + this.state.totalNumberOfResponses
                }
              />
              <StatsCard
                imgUrl={TimeSpentIcon}
                cardLabel="Time Spent"
                cardBody={this.state.timeSpent + " minutes"}
              />
              <StatsCard
                imgUrl={PercentageIcon}
                cardLabel="Percentage"
                cardBody={this.state.percentage.toFixed(2)}
              />
              <StatsCard
                imgUrl={AccuracyIcon}
                cardLabel="Accuracy"
                cardBody={
                  (this.state.accuracy ? this.state.accuracy.toFixed(2) : 0) +
                  " %"
                }
              />
            </div>
          </div>
          {/* Footer */}
          <div className={classes.Footer}>
            <MButton
              className={classes.SeeSolutionBtn}
              variant="contained"
              autoFocus
              onClick={this.goToSeeSlotuion}
            >
              {t("See Solution")}
            </MButton>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    assessmentData: state.assessmentsReducer.assessmentdata,
    assessmentResponse: state.questionanswer.assessmentresponse,
    result: state.questionanswer.assessmentResult,
    isKtvAssessment: state.assessmentsReducer.isKtvAssessment
  };
};

export default connect(mapStateToProps, { getResult, getAssessmentResponce })(
  withRouter(withTranslation()(AssignmentResult))
);
